import { Krr } from "../../../../../types/session";

export type PersonUserInputAction = {
  type: "SET_PERSON_USER_INPUT";
  input: Partial<Krr>;
};

export function setPersonUserInputAction(
  input: Partial<Krr>,
): PersonUserInputAction {
  return {
    type: "SET_PERSON_USER_INPUT",
    input,
  };
}

export type UserAction = PersonUserInputAction;
